import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {ModalSelectorComponent} from '../modal-selector/modal-selector.component';
import {ModalController} from '@ionic/angular';

@Component({
  selector: 'app-search-selector',
  templateUrl: './search-selector.component.html',
  styleUrls: ['./search-selector.component.scss'],
  standalone: false
})
export class SearchSelectorComponent implements OnChanges {

  @Input() lines?: string;

  @Input() items: any[] = [];
  @Input() itemsValueField: string = 'id';
  @Input() itemsLabelField: string = 'nombre';
  @Input() itemsImageField: string = '';
  @Input() itemsDescriptionField: string = '';

  @Input() label: string = '';
  @Input() placeholder: string = '';
  
  @Input() searchText: string = 'COMMON.SEARCH';
  @Input() cancelText: string = 'COMMON.CANCEL';
  @Input() resetText: string = 'COMMON.CLEAN';
  @Input() closeText: string = 'COMMON.CLOSE';
  @Input() doneText: string = 'COMMON.SAVE';

  @Input() groupItems: boolean = false;
  @Input() groupValueField: string = 'id';
  @Input() groupTextField: string = 'nombre';

  @Input() helperText?: string;
  @Input() isIncorrectValue: boolean = false;

  @Input() multiple: boolean = false;
  @Input() disabled: boolean = false;
  @Input() disabledReset: boolean = false;
  @Input() showLoader: boolean = false;

  @Input() value: any;
  @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();

  selectedTextValue?: string;
  itemsToList: any[] = [];

  constructor(
    protected modalCtrl: ModalController
  ) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['items'] || changes['value']) {
      this.setValues();
    }
  }


  /**
   * Establecer valores
   *
   */
  setValues() {

    if (this.items) {
      this.itemsToList = this.items;
    }

    if (this.multiple) {
      this.setValuesWhenMultiple();
      return;
    }

    this.setValuesWhenNotMultiple();
  }


  /**
   * Establecer valor cuando es múltiple
   *
   */
  setValuesWhenMultiple() {

    if (!this.itemsToList) {
      return;
    }

    this.selectedTextValue = '';

    this.itemsToList.forEach((item) => {
      item.is_checked = false;

      if (this.value || this.value === 0) {
        const isSelected = this.value.includes(item[this.itemsValueField]);

        if (isSelected) {
          this.selectedTextValue += item[this.itemsLabelField] + ', ';
          item.is_checked = true;
        }
      }
    });

    this.selectedTextValue = this.selectedTextValue ? this.selectedTextValue.slice(0, -2) : '';
  }


  /**
   * Establecer valor cuando es único
   *
   */
  setValuesWhenNotMultiple() {

    if (!this.itemsToList) {
      return;
    }

    this.selectedTextValue = '';

    this.itemsToList.forEach((item) => {
      item.is_checked = false;

      if (item[this.itemsValueField] === this.value) {
        this.selectedTextValue = item[this.itemsLabelField];
        item.is_checked = true;
      }
    });
  }


  /**
   * Abrir vista modal para seleccionar un valor
   *
   */
  async openSelectorModal() {
    const modal = await this.modalCtrl.create({
      component: ModalSelectorComponent,
      componentProps: {
        searchText: this.searchText,
        cancelText: this.cancelText,
        resetText: this.resetText,
        closeText: this.closeText,
        doneText: this.doneText,
        title: this.label,
        items: this.items,
        itemsValueField: this.itemsValueField,
        itemsLabelField: this.itemsLabelField,
        itemsDescriptionField: this.itemsDescriptionField,
        itemsImageField: this.itemsImageField,
        groupItems: this.groupItems,
        groupValueField: this.groupValueField,
        groupTextField: this.groupTextField,
        value: this.value,
        multiple: this.multiple,
        disabledReset: this.disabledReset,
      },
      cssClass: 'yu-modal',
    });

    modal.onDidDismiss().then((data) => {

      if (data.data || data.data === 0 || data.role === 'reset') {
        this.value = data.data;
        this.valueChange.emit(this.value);
      }

    });

    await modal.present();
  }

}
